module.exports = __webpack_public_path__ + "img/logo.0456f682.png";